<template>
  <ContentComponent />
</template>

<script>
import ContentComponent from '@/components/GrantsPage/ContentComponent'

export default {
  name: 'Grants',
  components: {
    ContentComponent
  }
}
</script>

<style lang="sass" scoped>
</style>
